app.service("AccountService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;
    const requestService = $rootScope.service.request;

    const config = {
        denied_role_routes: {
            deny_marketing_assets: "marketing-assets"
        }
    }

    const AccountModel = function () {
        this.user_data = null;
        this.customer_data = null;
        this.minimumDataCallbacks = [];
        this.had_minimum_data = false;
        this.is_blossom_customer = false;
        this.user_role = [];
        const fromPageVars = typeof page_vars !== 'undefined' && page_vars ? page_vars : {};
        this.is_login_required = !!fromPageVars.is_login_required;
    }


    this.model = new AccountModel();
    const model = this.model;

    this.getCustomerCode = function () {
        return model.customer_data ? model.customer_data.customer_code : null;
    }

    this.requireUserData = function (callback) {

        if (model.user_data && model.user_data.user_type) {
            if (callback) {
                callback(true, model.user_data, []);
            }
        } else {
            service.requestUserData(callback);
        }

    }

    this.requestUserData = function (callback) {

        const endpoint = '/request/api.php/users/_me?include_customer_data=true';
        requestService.getRequest(endpoint, function (success, userData, messages) {

            if (userData) {

                applyUserData(userData, callback);

            } else {
                if (callback) {
                    callback(false, null, messages);
                }
            }
        });
    }

    function updateIsBlossomCustomer() {

        const isBlossomCustomer = (!!model.customer_data && !!model.customer_data.blossom_avenue) ||
            (!!model.user_data && model.user_data.username === "blossommybacustomer@minus40.co");
        if (isBlossomCustomer !== model.is_blossom_customer) {
            model.is_blossom_customer = isBlossomCustomer;
            if (!isBlossomCustomer) {
                localStorage.removeItem("is_blossom_customer");
            } else {
                localStorage.setItem("is_blossom_customer", "1");
            }
            updateBlossomBodyClass();
        }

    }

    function applyUserData(userData, callback) {

        function onComplete(success, customerData, messages) {
            model.user_data = success ? userData : null
            updateIsBlossomCustomer();
            if (success) {
                handleAccountDataReplaced();
            }
            if (callback) {
                callback(success, userData, messages);
            }
        }

        $rootScope.service.staff.applyUserDataToStaff(userData, function (success, staffCustomerData, messages) {
            if (!$rootScope.model.staff.is_staff_or_rep) {
                const customerData = userData.customer;

                $rootScope.service.currency.requireCurrency(customerData.currency, function (success, currencyData, messages) {
                    if (success) {
                        customerData.currencyData = currencyData;
                        service.applyCustomerData(customerData);
                    }
                    onComplete(success, customerData, messages)
                });
            } else {
                onComplete(success, staffCustomerData, messages)
            }
        })
    }

    this.applyCustomerData = function (customerData) {
        model.customer_data = customerData;
        updateIsBlossomCustomer();
        handleAccountDataReplaced();
    }

    this.haveMinimumData = function (requireCustomer) {
        if (!model.user_data) {
            return false;
        }
        if (!$rootScope.model.staff.is_staff_or_rep) {
            return true;
        }
        if (!$rootScope.model.staff.staff_rep_customer_code) {
            return !requireCustomer;
        }
        return !!model.customer_data;
    }

    this.requireMinimumData = function (callback) {
        if (service.haveMinimumData()) {
            callback();
        } else {
            model.minimumDataCallbacks.push(callback);
        }
    }

    function handleAccountDataReplaced() {
        if (service.haveMinimumData()) {
            $rootScope.service.order.applyAccountDataToCurrentOrder();
            $rootScope.$broadcast("account_data_replaced");
            if (!model.had_minimum_data) {
                model.had_minimum_data = true;
                for (let i = 0; i < model.minimumDataCallbacks.length; i++) {
                    model.minimumDataCallbacks[i]();
                }
                model.minimumDataCallbacks.length = 0;

                $rootScope.$broadcast("minimum_data_received");
            }
        }
    }

    this.deleteSagepayToken = function (sagepayTokenID, callback) {

        const endpoint = '/request/api.php/sagepay_tokens/' + sagepayTokenID;

        requestService.deleteRequest(endpoint, null, function (success, data, messages) {
            if (success) {
                delete model.user_data.sagepay_tokens[sagepayTokenID];
                handleAccountDataReplaced();
            }
            if (callback) {
                callback(success, data, messages)
            }
        })
    }

    this.addNewAddress = function (address, callback) {

        address.type = "address";
        address.notes = "";

        const endpoint = '/request/api.php/users/' + model.user_data._nid + '/addresses';

        requestService.postJsonRequest(endpoint, address, function (success, address, errors) {
            function handleCallback(success, address, errors) {
                if (callback) {
                    callback(success, address, errors);
                }
            }

            if (success) {
                service.requestUserData(function (success, userData, errors) {
                    callback(success, address, errors);
                });
            } else {
                handleCallback(false, address, errors)
            }
        });
    }

    this.editAddress = function (address, callback) {

        const endpoint = '/request/api.php/users/' + model.user_data._nid + '/addresses/' + address._id;

        requestService.postJsonRequest(endpoint, address, function (success, address, errors) {
            function handleCallback(success, address, errors) {
                if (callback) {
                    callback(success, address, errors);
                }
            }

            if (success) {
                service.requestUserData(function (success, userData, errors) {
                    callback(success, address, errors);
                });
            } else {
                handleCallback(false, address, errors)
            }
        });
    }

    this.deleteAddress = function (addressID, callback) {

        const endpoint = '/request/api.php/users/' + model.user_data._nid + '/addresses/' + addressID;

        requestService.deleteJsonRequest(endpoint, null, function (success, data, errors) {
            function handleCallback(success, data, errors) {
                if (callback) {
                    callback(success, data, errors);
                }
            }

            if (success) {
                service.requestUserData(function (success, userData, errors) {
                    callback(success, data, errors);
                });
            } else {
                handleCallback(false, data, errors)
            }
        });
    }

    this.changeEmailAddress = function (newEmailAddress, callback) {

        const endpoint = '/request/api.php/users/' + model.user_data._nid;

        const postData = {
            type: "user",
            username: newEmailAddress
        }

        requestService.postJsonRequest(endpoint, postData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.changePassword = function (currentPassword, newPassword, callback) {

        const endpoint = '/request/api.php/users/' + model.user_data._nid;

        const postData = {
            type: "user",
            current_password: currentPassword,
            password: newPassword,
            resetPassword: true
        }

        requestService.postJsonRequest(endpoint, postData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.changeDespatchNote = function (despatchNote, callback) {

        const endpoint = '/request/api.php/customers/' + service.getCustomerCode()

        const postData = {
            type: "customer",
            despatch_note: despatchNote
        }

        requestService.postJsonRequest(endpoint, postData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (success && model.customer_data) {
                model.customer_data.despatch_note = despatchNote;
                handleAccountDataReplaced();
            }
            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.updateDealerLocator = function (dealerLocator, callback) {

        const endpoint = '/request/api.php/customers/' + service.getCustomerCode()

        const postData = {
            type: "customer",
            dealer_locator: dealerLocator
        }

        requestService.postJsonRequest(endpoint, postData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (success && model.customer_data) {
                model.customer_data.dealer_locator = dealerLocator;
                handleAccountDataReplaced();
            }
            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.makeAccountPayment = function (paymentData, callback) {

        const endpoint = '/request/api.php/accounts/payments/submit';

        requestService.postJsonRequest(endpoint, paymentData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.getAccountPaymentStatus = function (orderID, callback) {

        const endpoint = '/request/api.php/accounts/payments/' + orderID;

        requestService.getRequest(endpoint, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }
            if (callback) {
                callback(success, data, errors);
            }
        })
    }

    this.loginUser = function (loginData, callback) {

        const endpoint = '/request/api-authorize.php/login';

        requestService.postJsonRequest(endpoint, loginData, function (success, data, errors) {

            let doesAcquiredCacheExist = false;

            if (typeof page_vars !== 'undefined' && page_vars) {

                if (page_vars.hasOwnProperty('does_acquired_cache_exist')) {
                    doesAcquiredCacheExist = !!page_vars.does_acquired_cache_exist;
                }
            }

            if (!doesAcquiredCacheExist) {
                //There was no cached api file created on this server.
                //Because this user has only just logged in we were unable to create one before they logged.

                //We now have to redirect them to the same page so that this file can be created an is available for them to use

                window.location = "/";
                callback(false, data, siteHelper.addErrorMessage("Will Redirect"));

                return;
            }

            if (success) {

                data.user.customer = data.customer;
                model.user_role = data.user_role ? data.user_role : model.user_role;

                applyUserData(data.user);

                $rootScope.service.staff.setStaffRepCustomerCode(null);

            } else {
                if (errors.length > 0 && errors[0].message_id === "default_message") {
                    errors.splice(0, 1);
                    siteHelper.addErrorMessage("You have been logged out.  \n Please Refresh.", errors)
                }
            }

            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.registerUser = function (registerData, callback) {

        const endpoint = '/request/api-authorize.php/register';

        requestService.postJsonRequest(endpoint, registerData, function (success, data, errors) {
            if (data && data._errors) {
                success = false;
                siteHelper.addErrorMessage(data._errors, errors);
            }

            if (callback) {
                callback(success, data, errors);
            }
        });
    }

    this.postcodeLookup = function (postcode, callback) {
        postcode = postcode ? postcode.replace(/ /g, '').toUpperCase() : "";

        const endpoint = '/request/api.php/postcodes/' + postcode;
        requestService.getRequest(endpoint, function (success, data, messages) {
            const addresses = success ? data.addresses : null;
            if (!addresses || addresses.length === 0) {
                success = false;
                if (messages.length === 0) {
                    siteHelper.addErrorMessage("Postcode not found", messages);
                }
            }
            if (callback) {
                callback(success, addresses, messages)
            }
        });
    }

    this.isMasterAdmin = function (allowCookie) {
        const isStaff = $rootScope.model.staff.is_staff || (allowCookie && !!localStorage.getItem('is_staff'))
        if (isStaff) {
            return true;
        }
        const isCompleteTestAccount = $rootScope.model.staff.is_complete_test_account || (allowCookie && !!localStorage.getItem('is_complete_test_account'))
        if (isCompleteTestAccount) {
            return true;
        }
        if ($rootScope.model.cache_local_server.is_local_admin_available) {
            const isPrimaryTestAccount = $rootScope.model.staff.is_primary_test_account || (allowCookie && !!localStorage.getItem('is_primary_test_account'))
            if (isPrimaryTestAccount) {
                return true;
            }
        }
        return false;
    }

    this.isDevModeAvailable = function () {
        return service.isMasterAdmin();
    }
    this.isRouteDenied = function (checkForRoute) {
        for (let role in config.denied_role_routes) {
            if ($rootScope.model.account.user_role.includes(role)) {
                let routes = config.denied_role_routes[role];
                routes = Array.isArray(routes) ? routes : [routes];
                for (let i = 0; i < routes.length; i++) {
                    if ($rootScope.site_helper.doesMatchPath(routes[i], checkForRoute)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function updateBlossomBodyClass() {
        const isBlossomCustomer = model.is_blossom_customer;
        const body = angular.element(document).find('body');
        if (!isBlossomCustomer) {
            body.removeClass("is_blossom_customer");
            body.addClass("not_blossom_customer");
        } else {
            body.removeClass("not_blossom_customer");
            body.addClass("is_blossom_customer");
        }
    }

    function determineIsBlossomCustomer() {
        model.is_blossom_customer = !!localStorage.getItem('is_blossom_customer');
        updateBlossomBodyClass();
    }

    this.indexInit = function () {

        determineIsBlossomCustomer();

    }

}]);